import { cn } from "@/lib/utils";

type IndicatorDotProps = {
  text?: string;
  /**
   * CSS Variable for the border color, e.g. `--card`. If not provided, no border will be shown.
   */
  border?: `--${string}`;
  className?: string;
};

export function IndicatorDot({ text, border, className }: IndicatorDotProps) {
  const style = border
    ? { boxShadow: `0 0 0 2px hsl(var(${border}))` }
    : undefined;

  if (text) {
    return (
      <div
        className={cn(
          "bg-primary text-background flex items-center justify-center rounded-full px-1 py-0 text-xs font-medium",
          className,
        )}
        style={style}
      >
        {text}
      </div>
    );
  }
  return (
    <div
      className={cn(
        "bg-primary flex h-1.5 w-1.5 items-center justify-center rounded-full",
        className,
      )}
      style={style}
    />
  );
}
